import { CARGO_TYPE, getCapacityCargoTypeLabel, LTL_FAMILY_CARGO_TYPES } from '@types';

/* The Booked Shipments (Labels) table groups Pallets/Bundle/Skid/Other rows into one LTL capacity
   bucket - the same "less than load" family Step2's booking form treats as one unit - and shows
   the specific type breakdown in the Cargo column instead (getMixedCargoTransportDescription). */
export const getBookedShipmentCargoTypeLabel = (cargoType?: CARGO_TYPE): string => {
	if (cargoType && LTL_FAMILY_CARGO_TYPES.includes(cargoType)) {
		return 'LTL';
	}
	return getCapacityCargoTypeLabel(cargoType as CARGO_TYPE);
};
